export default {
  demoDemographics: {
    title: 'Demographics', // datasource !== 10 or datasource !== 200 Demographic Options
    demoType: 'demoDemographics',
    access: true
    
  },
  businessType: {
    title: 'Business Type',
    demoType: 'businessType',
    access: true,
    video: ''
  },
  intrestsPurchasing: {
    title: 'Interests & Purchasing',
    demoType: 'intrestsPurchasing',
    access: true
  },
  audiencePropensities: {
    title: 'Audience Propensities',
    demoType: 'audiencePropensities',
    access: true
  },
  quickPicks: {
    title: 'QuickPicks',
    demoType: 'quickPicks',
    access: true
  },
  businessQuickPicks: {
    title: 'Business QuickPicks',
    demoType: 'businessQuickPicks',
    access: true
  },
  suppression: {
    title: 'Suppression',
    demoType: 'suppression',
    access: true
  },
  search: {
    title: 'Search',
    demoType: 'search',
    access: true
  },
  residentOccupantList: {
    title: 'Resident Occupant Lists',
    demoType: 'residentOccupantList',
    access: true
  }
}



// WEBPACK FOOTER //
// ./src/config/demoType.js